export const experience = [
    {
        jobName: 'Desenvolvedor de Software - Agência Hunters',
        date: "jan 2022 - atualmente",
        jobDescription: ['- Desenvolvi aplicações web como sistemas de agendamentos, landing pages, help desk.',
            '- Responsável pela manutenção e implementação de projetos utilizando Html, Css, Javascript, React, Node, PHP ,Laravel, C# e Mysql.',
        ]
    },
]

export const education = [
    {
        name: 'Técnico em Informática - Senac Amazonas',
        date: 'junho de 2020 - maio de 2022',
        description: [`- Ao decorrer do meu curso técnico atuei como Desenvolvedor Full Stack de uma 
        aplicação web para instituição Senac Amazonas: `, ' * Nome do Projeto: Talentos em Tecnologia. ',
            ' * Ferramentas: Laravel, Html, css e Javascript.']
    },
    {
        name: 'Análise e desenvolvimento de sistemas - Fametro',
        date: '2022 - 2024',
        description: ['- Cursando 2º Período - Tecnólogo em Análise e Desenvolvimento de Sistemas.']
    },
]


export const portifolio = [
    {
        type: 'web',
        img: '/img/jogo-da-velha.png',
        name: 'Jogo da Velha',
        gitHub: 'https://github.com/patrickassuncao1/jogo-da-velha-react',
        demonstration: 'https://jogo-da-velha-react-js-patrick.vercel.app'
    },
    {
        type: 'mobile',
        img: '/img/behance-mobile.png',
        name: 'Eat & Drink ',
        link: 'https://www.behance.net/gallery/136167199/Eat-Drink-Mobile-App-UXUI?tracking_source=search_projects%7Cmobile%20app%20design',
        gitHub: 'https://github.com/patrickassuncao1/Mobile-App-Behance-Clone'
    },
    {
        type: 'web',
        img: '/img/e-commerce.png',
        name: 'E-coomerce',
        gitHub: 'https://github.com/patrickassuncao1/e-commerce-front-end',
    },
]